import React from "react";
import CartContext from "@/contexts/cart-context";
import CartContextV2 from "@/contexts/cart-context-v2";

interface Props {
  productShown: boolean;
}

const FloatingCartAction: React.FC<Props> = ({ productShown }) => {
  const { cart, modals, price, toggleModal } = CartContextV2.useContainer();
  const cartLength = cart.length;

  if (modals?.cart || cartLength === 0 || productShown) {
    return null;
  }

  return (
    <div className="z-[980] w-full invisible cursor-pointer left-0 right-0 bottom-10 md:bottom-15 fixed px-5 sm:px-9 md:px-12.5">
      <div className="store-container flex justify-center md:justify-end ">
        <div
          onClick={() => toggleModal("cart")}
          className="z-[999] visible bg-primary-500 max-sm:w-full rounded-full gap-25 md:gap-15 shadow-lg pl-4.5 pr-3.75 py-3 relative flex items-center justify-between"
        >
          <div className="flex text-sm">
            <p className="text-1xs md:text-sm font-semibold text-white pt-0.5">
              {cartLength} {cartLength > 1 ? "Items" : "Item"} ({price})
            </p>
          </div>
          <figure className="h-9 w-9 bg-white flex items-center justify-center rounded-full flex-shrink-0">
            <svg className="w-1/2 text-primary-500" viewBox="0 0 18 18" fill="none">
              <path
                d="M3.75 9H14.25M14.25 9L9 3.75M14.25 9L9 14.25"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default FloatingCartAction;
